import { normalizeConfidence } from "./caseReviewFieldState";
import type { KeyValuePair } from "@/interface/key-value.interface";
import type { ResolvedHighlightLocations } from "@/lib/boundingBox/SourceLocationResolver";

const CONFIDENCE_CODE = { high: "H", medium: "M", low: "L" } as const;

export interface SourceHighlightInput {
  fieldId: string | undefined;
  label: string;
  value: unknown;
  confidence: string | undefined;
  locations: ResolvedHighlightLocations;
}

/** The `setSelectedField` payload for one source-evidence selection, built once for every caller. */
export function sourceHighlightPayload({ fieldId, label, value, confidence, locations }: SourceHighlightInput): KeyValuePair {
  return {
    field: fieldId ?? label,
    fieldname: fieldId ?? label,
    content: value === undefined || value === null ? "" : String(value),
    confidence: CONFIDENCE_CODE[normalizeConfidence(confidence ?? "")],
    // Each click is a new navigation request, even for the same field. The viewer watches these
    // arrays; reusing the memoized references makes a second click silently do nothing.
    bounding_regions: [...locations.boundingRegions],
    bounding_region_groups: locations.locationGroups.map((group) => [...group]),
  };
}
